import { Injectable } from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import { HttpAuth } from './http-auth.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable()
export class VenueService {

  private url: string = `${ environment.apiRoot }/venue/`;

  constructor(private http: HttpAuth) {
  }

  public getVenuesByPage(page?: number, pagecount?: number, query?: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '5');
    }

    if (query) {
        params.set('query', query);
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.url, options)
      .map(this.extractData)
      .catch((error:any) => Observable.throw(error.json().meta || {message:'server error', status:0}));
  }
    
  public getVenuesById(id): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();

    params.append('id', id);
    let options = new RequestOptions({search: params});

    return this.http.get(this.url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getVenues(): Observable<any> {
    return this.http.get(this.url)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postVenues(venue): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    const body = venue;

    let options = new RequestOptions({search: params});

    return this.http.post(this.url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putVenues(venue): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    let auxId = venue.id;
    venue.id = venue.id;
    venue.id = auxId;
    const body = venue;

    let options = new RequestOptions({search: params});

    return this.http.put(this.url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public deleteVenues(venueID): Observable<any> {

    const body = JSON.stringify({id: venueID});

    return this.http.delete(this.url, new RequestOptions({
      body: body
    }))
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/venue.service.ts